import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getQuotaAddingReps, createQuotaInfo, createQuotaInfoOverride } from '../redux/management.thunk';
import { selectCurrentQuotaData, clearCurrentQuotaData, selectTempHireDate, selectTempTeam, clearCreateSuccess } from '../redux/management.slice';
import RepsListTable from './RepsListTable';
import QuotaEditorModal from './QuotaEditorModal';
import ConflictDialog from './ConflictDialog';

const AddQuotaForReps = () => {
  const dispatch = useDispatch();
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [conflictDialogOpen, setConflictDialogOpen] = useState(false);
  const [conflictData, setConflictData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const { quotaAddingReps } = useSelector((state) => state.management);
  const currentQuotaData = useSelector(selectCurrentQuotaData);
  const tempHireDate = useSelector(selectTempHireDate);
  const tempTeam = useSelector(selectTempTeam);
  console.log('Checking_Team:', tempTeam);
  

  useEffect(() => {
    dispatch(getQuotaAddingReps());
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(currentQuotaData) && currentQuotaData.length > 0) {
      const conflicts = currentQuotaData.filter(item => item.canUpsert === false);
      if (conflicts.length > 0) {
        setConflictData(currentQuotaData);
        setConflictDialogOpen(true);
      }
    } else if (currentQuotaData) {
      // If currentQuotaData is present but not an array, avoid calling array methods.
      // This can happen when the backend returns an error message string or object.
      console.warn('currentQuotaData is not an array:', currentQuotaData);
      setConflictData([]);
      setConflictDialogOpen(false);
    }
  }, [currentQuotaData]);

  const handleOpenModal = (userId, userName) => {
    setSelectedUser(userName);
    setSelectedUserId(userId);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedUser(null);
    setSelectedUserId(null);
    dispatch(clearCreateSuccess());
  };

  const handleConflictDialogClose = () => {
    setConflictDialogOpen(false);
    setConflictData([]);
    dispatch(clearCurrentQuotaData());
  };

  const handleOverwriteConfirm = () => {
    const updatedConflictData = conflictData.map(item => ({
      ...item,
      canUpsert: true
    }));

    // Construct the payload for quotaAssignments
    const quotaAssignmentsPayload = updatedConflictData.map(item => ({
      NQP_Goal: item.NQP_Goal,
      quota: item.quota,
      rampStatus: item.rampStatus,
      fiscalQuarter: item.fiscalQuarter,
      userId: item.userId,
      team: Array.isArray(item.team) ? item.team[0] : item.team, // ensure team is a string
      fullName: item.fullName,
      sfdcOwnerId: item.sfdcOwnerId,
      canUpsert: true
    }));

    // Construct the createQuotaBody with top-level hireDate and team
    const createQuotaBody = {
      hireDate: tempHireDate, // Use tempHireDate from Redux store
      team: Array.isArray(tempTeam) ? tempTeam[0] : tempTeam, // ensure string
      quotaAssignments: quotaAssignmentsPayload,
    };

    console.log('createQuotaBodyLog',createQuotaBody);


    dispatch(createQuotaInfoOverride({ createQuotaBody, showSuccessToast: true }));
    handleConflictDialogClose();
  };

  return (
    <div>
      <RepsListTable
        reps={quotaAddingReps || []}
        onRepClick={handleOpenModal}
        isLoading={!quotaAddingReps}
      />

      <ConflictDialog
        open={conflictDialogOpen}
        onClose={handleConflictDialogClose}
        onConfirm={handleOverwriteConfirm}
        conflictData={conflictData}
      />

      {modalOpen && (
        <QuotaEditorModal
          open={modalOpen}
          onClose={handleCloseModal}
          selectedUser={selectedUser}
          selectedUserId={selectedUserId}
        />
      )}
    </div>
  );
};

export default AddQuotaForReps;
